import {styledByTheme} from "../../../../../../themes/architecture/styled-by-theme";
import {BurgerIconDefaultBox} from "./burger-icon.default.box";
import {BurgerIconCasino777Box} from "./burger-icon.casino777.box";
import {BurgerIconSiBox} from "./burger-icon.si.box";

export const BurgerIconBox = styledByTheme(BurgerIconDefaultBox)
                                .forCasino777(BurgerIconCasino777Box)
                                .forSI(BurgerIconSiBox)
                                .apply();